export default __webpack_public_path__ + "static/media/graphic-06.9e2bd606.png";